export default __webpack_public_path__ + "static/media/backVertical.69b0070b.png";